import React from "react";
import PropTypes from "prop-types";
import { Chip, colors } from "@qgiv/core-react";
import ConnectedCommitmentDetailsChipContent from "./ConnectedCommitmentDetailsChipContent";

const CommitmentDetailsChip = ({
    categoryId,
    classNames = "",
    location,
    managedByPrimary = false,
    details,
}) => {
    // commitment chips display as system warning yellow and system light grey when used for the fundraising goal
    const bgColor =
        location === "category" ? colors.SYSTEM_WARNING : colors.SYSTEM_LIGHT;
    return (
        <Chip bgColor={bgColor} classNames={classNames}>
            <ConnectedCommitmentDetailsChipContent
                categoryId={categoryId}
                location={location}
                managedByPrimary={managedByPrimary}
                details={details}
            />
        </Chip>
    );
};

CommitmentDetailsChip.propTypes = {
    details: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string])
        .isRequired,
    location: PropTypes.string.isRequired,
    categoryId: PropTypes.number.isRequired,
    classNames: PropTypes.string,
    managedByPrimary: PropTypes.bool,
};

export default CommitmentDetailsChip;
